/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const HumanOutlinedIcon = createIcon({
    displayName: 'HumanOutlinedIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M15.333 7.333c0 2.141-1.193 3.334-3.333 3.334S8.666 9.474 8.666 7.333C8.666 5.193 9.86 4 12 4s3.333 1.193 3.333 3.333Zm-1.333 0c0-1.402-.598-2-2-2-1.402 0-2 .598-2 2 0 1.402.598 2 2 2 1.402 0 2-.598 2-2Zm4.065 6.823c.396.212.697.524.844.896.213.537.409 1.25.423 2.096A6.06 6.06 0 0 1 18.66 20H5.39c-.31-.568-.808-1.685-.71-3.124a5.629 5.629 0 0 1 .45-1.846c.154-.357.448-.655.832-.862a12.867 12.867 0 0 1 6.248-1.5c2.73.038 4.77.906 5.855 1.488ZM6.25 18.666h11.524a4.566 4.566 0 0 0-.105-3.124c-.02-.05-.093-.135-.234-.211a11.444 11.444 0 0 0-5.243-1.33L12.026 14c-2.427 0-4.294.73-5.432 1.343-.141.075-.216.16-.24.214a4.302 4.302 0 0 0-.345 1.41c-.044.65.074 1.228.24 1.7Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M17 5c0 3.21-1.79 5-5 5S7 8.21 7 5s1.79-5 5-5 5 1.79 5 5Zm-2 0c0-2.103-.897-3-3-3-2.103 0-3 .897-3 3 0 2.103.897 3 3 3 2.103 0 3-.897 3-3Zm6.098 9.234c.594.319 1.046.786 1.266 1.344a8.96 8.96 0 0 1 .635 3.143A9.09 9.09 0 0 1 21.989 23H2.086c-.466-.852-1.213-2.528-1.066-4.686a8.46 8.46 0 0 1 .676-2.769c.23-.536.673-.983 1.248-1.292C4.576 13.374 7.771 12 12.04 12c.092 0 .184 0 .277.002 4.094.057 7.155 1.36 8.782 2.232ZM3.375 21h17.287a6.854 6.854 0 0 0-.158-4.687c-.03-.075-.139-.203-.351-.316-1.647-.884-4.348-1.946-7.865-1.995L12.039 14c-3.64 0-6.44 1.095-8.148 2.014-.211.114-.324.24-.359.322a6.453 6.453 0 0 0-.518 2.114 6.355 6.355 0 0 0 .36 2.55Z",
            clipRule: "evenodd"
        })
    ]
});
HumanOutlinedIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'HumanOutlinedIcon'
};
export { HumanOutlinedIcon };

//# sourceMappingURL=human_outlined.js.map